import {FC} from 'react'
import {IProductModel} from '../../cors/_models'
import SpecialSelectionTableRow from './SpecialSelectionTableRow'
import {useIntl} from 'react-intl'

interface IProps {
  data: IProductModel[]
  selectedProductIDs: number[]
  onToggle: (productID: number) => void
}

const SpecialSelectionTable: FC<IProps> = ({data, selectedProductIDs, onToggle}) => {
  const {formatMessage} = useIntl()

  return (
    <table className='aos-table'>
      <thead>
        <tr>
          <th style={{width: '48px'}}></th>
          <th>{formatMessage({id: 'image'})}</th>
          <th>{formatMessage({id: 'prod_name'})}</th>
          <th>{formatMessage({id: 'barcode'})}</th>
          <th>{formatMessage({id: 'model_num'})}</th>
          <th className='aos-right'>{formatMessage({id: 'sale_price'})}</th>
        </tr>
      </thead>
      <tbody>
        {data &&
          data.map((item) => (
            <SpecialSelectionTableRow
              selectedProductIDs={selectedProductIDs}
              onChange={onToggle}
              key={item.product_id}
              item={item}
            />
          ))}
      </tbody>
    </table>
  )
}

export default SpecialSelectionTable
